export enum Languages {
    KZ = 'kk',
    RU = 'ru'
}